import { createAsyncThunk } from "@reduxjs/toolkit";
import { simplifyFriendsList } from "../../helper";

import apiInstance from "../../config/api";



export const getUserDetails = createAsyncThunk(
  "users/details",
  async (userId) => {
    try {
      const request = await apiInstance.get(`/api/friends/friendship-status-user-details/${userId}`)
      const response = request.data
      console.log('get user response; ', response)
      if (response.message === "User found") {
        const newData = {
          ...response.user,
          friendshipStatus: response.friendshipStatus.message,
          albumCount: response.albumCount,
          friendCount: response.friendCount,
          postsCount: response.postsCount,
          reelsCount: response.reelsCount
        };
        // console.log("user by id details; ", newData);
        return newData;
      } else if (response.message === "You have blocked this user. Unblock?") {
        return {
          ...response.user,
          isBlocked: "BY-ME"
        }
      } else if (response.message === "You are blocked by this user.") {
        return {
          ...response.user,
          isBlocked: "BY-USER"
        }
      }
      else if (response.message === "This user has set their account to private") {
        return {
          isPrivate: true,
          ...(response.user ? response.user: {})
         }
      }
      else {
        throw new Error(response.message);
      }
    } catch (error) {
      throw new Error(error.message);
    }
  }
);


export const getUserFriends = createAsyncThunk('users/friends', async (userId) => {
  console.log('inconimg id ; ', userId)
  try {
    const request = await apiInstance.get(`/api/friends/others-friends/${userId}`)
    const response = request.data
    if (response.status === "success") {
      const friends = simplifyFriendsList(response.friendsListWithStatus)
      return friends
    } else {
      throw new Error(response.message)
    }
  }
  catch (error) {
    console.log('user friends error; ', error.message)
    throw new Error(error.message)
  }
})